var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxMailFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.80936C2 4.62589 2.95939 3.6665 4.14286 3.6665H19.8571C21.0406 3.6665 22 4.62589 22 5.80936V6.29786L12.5477 12.6005C12.4144 12.6862 12.2209 12.7474 12 12.7474C11.7791 12.7474 11.5856 12.6862 11.4523 12.6005L2 6.29788V5.80936ZM2 8.44415V17.9522C2 19.1356 2.95939 20.0951 4.14286 20.0951H19.8571C21.0406 20.0951 22 19.1356 22 17.9522V8.44413L13.5334 14.0895L13.5252 14.095C13.0757 14.3876 12.5359 14.5331 12 14.5331C11.4641 14.5331 10.9243 14.3875 10.4748 14.095L10.4665 14.0896L2 8.44415Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxMailFilled);
export default __webpack_public_path__ + "static/media/icon_24px_mail_filled.527e6de5f8e049da6a1cfe9d367fd9af.svg";
export { ForwardRef as ReactComponent };